import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

import Button from '@decisiv/ui-components/lib/components/Button';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const ClearAllButton = styled(Button)`
  margin-left: auto;
` as unknown as typeof Button;

/**
 * SearchInput is fluid (`flex: 1`) and ignores `className`, so its width has to
 * come from the parent. 400px matches the Figma spec for the tab header search.
 */
export const SearchInputWrapper = styled(Flex)`
  width: ${rem(spacing.base * 40)};
`;
